type SidebarItem = {
	label: string;
	route: string;
	children?: { label: string; route: string 
		children?: { label: string; route: string }[]
	}[];
  };
  
  const sidebarItems: { [key: string]: SidebarItem[] } = {
	admin: [
	  // Dashboard (single item)
	  { label: "Dashboard", route: "landing" },

	  { label: "Employee Information", route: "employeeinformation" },

    //   { label: "Assign Manager", route: "assign-manager" },

	  { label: "Create team", route: "createteam" },
	  { label: "Projects", route: "projects" },

	  // { label: "Ranking", route: "HARanking" }, // COMMENTED OUT - Ranking functionality hidden

	  // { label: "Permission", route: "permission" }, // COMMENTED OUT - Permission functionality hidden
	
	  // PMS - Performance Management System
	  {
		label: "PMS",
		route: "pms",
		children: [
		  { label: "Roles", route: "pms/designations" },
	  { label: "KRA Library", route: "pms/kra/library" },
	  { label: "All Reviews", route: "pms/kra/assignments" },
	  { label: "HR Review", route: "pms/kra/hr-review" },
		  { label: "360° Feedback", route: "pms/hr/360-feedback-dashboard" },
		],
	  },

	  // Peer Review — HR
	  {
		label: "Peer Review",
		route: "pms/peer-review",
		children: [
		  { label: "Cycles", route: "pms/peer-review/cycles" },
		  { label: "Templates", route: "pms/peer-review/templates" },
		  { label: "Dashboard", route: "pms/peer-review/hr-dashboard" },
		],
	  },

	  // COMMENTED OUT - Feedback section hidden (PMS feedback remains active)
	  // Feedback (with children)
	  // {
	  //   label: "Feedback",
	  //   route: "feedback",
	  //   children: [
	  //     { label: "Appraisal", route: "admin-appraisal" },
	  //     { label: "360 Degree", route: "three-sixty-admin" },
	  //     { label: "Organization Survey", route: "organization-survey" },
	  //   ],
	  // },
  
	  //  Reports (with nested children)
	  {
		label: "Operational Metrics",
		route: "reports",
		children: [
		  {
			label: "Compliance",
			route: "compliance",
			children: [
			  { label: "Compliance Dashboard", route: "compliance-dashboard" },
			  { label: "Add Compliance Templates", route: "process-compliance-templates" },
			  { label: "Assignments Compliance Templates", route: "process-compliance-assignments" },
			],
		  },
	  { label: "Jira Utilization", route: "utilization" },
	  { label: "All Attendance", route: "all-attendance" },
	  // { label: "Appraisal", route: "historical-appraisal" }, // COMMENTED OUT - Historical appraisal hidden
	],
  },

  // Skills (with children)
  {
	label: "Skills",
	route: "skills",
	children: [
	  { label: "Your Skills", route: "employee-skill-set" },
	  { label: "All Skills", route: "all-skills" },
	],
  },

  // Training (with children)
  {
	label: "Training",
	route: "training",
	children: [
	  { label: "Training Master", route: "training-master" },
	  { label: "Training Dashboard", route: "training-dashboard" },
	],
  },

  // { label: "Manager History", route: "manager-history" }, // COMMENTED OUT - Manager History hidden

  // Client Feedback
  {
	label: "Client Feedback",
	route: "feedback",
	children: [
	  { label: "Feedback Templates", route: "feedback/templates" },
	  { label: "Feedback Requests", route: "feedback/requests" },
	],
  },
],
  
	// Other roles can be similarly structured
	employee: [
	  { label: "Dashboard", route: "landing" },
	  {
		label: "PMS",
		route: "pms",
		children: [
		  { label: "My KRA", route: "pms/kra/employee" },
		  { label: "PMS Dashboard", route: "pms/my-reviews" },
		  { label: "360° Feedback", route: "pms/360-feedback" },
		],
	  },
	  // COMMENTED OUT - Feedback section hidden (PMS feedback remains active)
	  // {
	  //   label: "Feedback",
	  //   route: "feedback",
	  //   children: [
	  //     { label: "Appraisal", route: "employee-appraisal" },
	  //     { label: "360 Degree", route: "three-sixty-employee" },
	  //     { label: "Organization Survey", route: "feedback-dashboard" },
	  //   ],
	  // },
	  {
		label: "Operational Metrics",
		route: "reports",
		children: [
	  { label: "Jira Utilization", route: "utilization" },
	  { label: "Attendance", route: "employee-attendance" },
	  { label: "My Compliance", route: "compliance-templates" },
	  // { label: "Performance", route: "historical-appraisal" }, // COMMENTED OUT - Historical appraisal hidden
	],
  },
  {
	label: "Skills",
	route: "skills",
	children: [
		{ label: "Your Skills", route: "employee-skill-set" },
		{ label: "Skill Document", route: "emp-skills-document" },
	],
  },
  
  // Training
  {
	label: "Training",
	route: "training",
	children: [
	  { label: "Training Dashboard", route: "training-dashboard" },
	  { label: "My Trainings", route: "my-trainings" },
	],
  },

  // Peer Review — Employee (last)
  { label: "Peer Review", route: "pms/peer-review/my-reviews" },
],
  
	hr: [
	  // HR-specific structure similar to admin but with potentially different permissions
	  { label: "Dashboard", route: "landing" },
	  { label: "Employee Information", route: "employeeinformation" },
	//   { label: "Assign Manager", route: "assign-manager" },
	  { label: "Create team", route: "createteam" },
	  { label: "Projects", route: "projects" },
	  // { label: "Ranking", route: "HARanking" }, // COMMENTED OUT - Ranking functionality hidden
	  // COMMENTED OUT - Forms functionality hidden
	  // { 
	  //   label: "Forms", 
	  //   route: "forms",
	  //   children: [
	  //     { label: "Add Form", route: "addForm" },	
	  //     { label: "Created Forms", route: "createdforms" },
	  //   ],
	  // },
	{
		label: "PMS",
		route: "pms",
		children: [
		  { label: "Roles", route: "pms/designations" },
	  { label: "KRA Library", route: "pms/kra/library" },
	  { label: "All Reviews", route: "pms/kra/assignments" },
	  { label: "HR Review", route: "pms/kra/hr-review" },
		  { label: "360° Feedback", route: "pms/hr/360-feedback-dashboard" },
		],
	},

	  // Peer Review — HR
	  {
		label: "Peer Review",
		route: "pms/peer-review",
		children: [
		  { label: "Cycles", route: "pms/peer-review/cycles" },
		  { label: "Templates", route: "pms/peer-review/templates" },
		  { label: "Dashboard", route: "pms/peer-review/hr-dashboard" },
		],
	  },

	  // COMMENTED OUT - Feedback section hidden (PMS feedback remains active)
	  // {
	  //   label: "Feedback",
	  //   route: "feedback",
	  //   children: [
	  //     { label: "Appraisal", route: "hr-appraisal" },
	  //     { label: "360 Degree", route: "three-sixty-hr" },
	  //     { label: "Organization Survey", route: "feedback-hr-dashboard" },
	  //   ],
	  // },
	  {
		label: "Operational Metrics",
		route: "reports",
		children: [
		  {
			label: "Compliance",
			route: "compliance",
			children: [
			  { label: "Compliance Dashboard", route: "compliance-dashboard" },
			  { label: "Add Compliance Templates", route: "process-compliance-templates" },
			  { label: "Assignments Compliance Templates", route: "process-compliance-assignments" },
			],
		  },
	  { label: "Jira Utilization", route: "utilization" },
	  { label: "All Attendance", route: "all-attendance" },
	  // { label: "Appraisal", route: "historical-appraisal" }, // COMMENTED OUT - Historical appraisal hidden
	],
  },
  {
	label: "Skills",
	route: "skills",
	children: [
	  { label: "Your Skills", route: "employee-skill-set" },
	  { label: "All Skills", route: "all-skills" },
	],
  },

  // Training (with children)
  {
	label: "Training",
	route: "training",
	children: [
	  { label: "Training Master", route: "training-master" },
	  { label: "Training Dashboard", route: "training-dashboard" },
	],
  },

  // { label: "Manager History", route: "manager-history" }, // COMMENTED OUT - Manager History hidden

  // Client Feedback
  {
	label: "Client Feedback",
	route: "feedback",
	children: [
	  { label: "Feedback Templates", route: "feedback/templates" },
	  { label: "Feedback Requests", route: "feedback/requests" },
	],
  },
],
  
	manager: [
	  // Manager-specific structure
	  { label: "Dashboard", route: "landing" },
	  // { label: "Subordinate", route: "subordinate" }, // COMMENTED OUT - Subordinate functionality hidden
	  // { label: "Ranking", route: "ranking" }, // COMMENTED OUT - Ranking functionality hidden
	  {
		label: "PMS",
		route: "pms",
		children: [
		  { label: "My KRA", route: "pms/kra/employee" },
		  { label: "Team Review", route: "pms/kra/manager-review" },
		  { label: "360° Feedback", route: "pms/manager-360-feedback" },
		],
	  },
	  // COMMENTED OUT - Feedback section hidden (PMS feedback remains active)
	  // {
	  //   label: "Feedback",
	  //   route: "feedback",
	  //   children: [
	  //     { label: "Appraisal", route: "manager-appraisal-component" },
	  //     { label: "360 Degree", route: "three-sixty-manager" },
	  //     { label: "Organization Survey", route: "feedback-manager-dashboard" },
	  //   ],
	  // },
	  {
		label: "Operational Metrics",
		route: "reports",
		children: [
	  { label: "Jira Utilization", route: "utilization" },
	  { label: "All Attendance", route: "all-attendance" },
	  { label: "My Compliance", route: "compliance-templates" },
	  // { label: "Performance", route: "historical-appraisal" }, // COMMENTED OUT - Historical appraisal hidden
	],
  },
	  {
		label: "Skills",
		route: "skills",
		children: [
		  { label: "Your Skills", route: "employee-skill-set" },
		  { label: "All Skills", route: "all-skills" },
		  { label: "Employee Skills", route: "skill-based-employee" },
		],
	  },

	  // Training
	  {
		label: "Training",
		route: "training",
		children: [
		  { label: "Training Dashboard", route: "training-dashboard" },
		  { label: "My Trainings", route: "my-trainings" },
		],
	  },

	  // Client Feedback
	  {
		label: "Client Feedback",
		route: "feedback",
		children: [
		  { label: "Feedback Requests", route: "feedback/requests" },
		],
	  },

	  // Peer Review — Manager (last)
	  { label: "Peer Review", route: "pms/peer-review/my-reviews" },
	],

	process_compliance_manager: [
	  { label: "Dashboard", route: "landing" },
	  {
		label: "Operational Metrics",
		route: "reports",
		children: [
		  {
			label: "Compliance",
			route: "compliance",
			children: [
			  { label: "Add Compliance Templates", route: "process-compliance-templates" },
			  { label: "Assignments Compliance Templates", route: "process-compliance-assignments" },
			],
		  },
		],
	  },
	],

	process_compliance_officer: [
	  { label: "Dashboard", route: "landing" },
	  {
		label: "Operational Metrics",
		route: "reports",
		children: [
		  { label: "My Compliance", route: "compliance-templates" },
		],
	  },
	],
  };
  
  export const getSidebarItems = (roleArray: string[]): SidebarItem[] => {
	const itemsMap = new Map<string, SidebarItem>();
  
	roleArray.forEach((role) => {
	  // Map roles to their corresponding sidebar key
	  const roleLower = role.toLowerCase();
	  const key = roleLower === "process compliance officer" ? "process_compliance_officer"
	            : roleLower === "process compliance manager" ? "process_compliance_manager"
	            : roleLower;
	  const roleItems = sidebarItems[key as keyof typeof sidebarItems];
	  if (roleItems) {
		roleItems.forEach((item) => {
		  if (!itemsMap.has(item.label)) {
			itemsMap.set(item.label, item);
		  }
		});
	  }
	});
  
	return Array.from(itemsMap.values());
  };
  
  
  export const getItems = (role: string): { label: string; route: string }[] => {
	let items: { label: string; route: string }[] = [];
	
	switch (role?.toLowerCase()) {
	  case "admin":
		items = [...items, ...sidebarItems.admin];
		break;
	  case "employee":
		items = [...items, ...sidebarItems.employee];
		break;
	  case "process compliance officer":
		items = [...items, ...sidebarItems.process_compliance_officer];
		break;
	  case "hr":
		items = [...items, ...sidebarItems.hr];
		break;
	  case "manager":
		items = [...items, ...sidebarItems.manager];
		break;
	  case "process compliance manager":
		items = [...items, ...sidebarItems.process_compliance_manager];
		break;
	  default:
		break;
	}
	
	return items;
  };
  